import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
const flyers = [{
  id: 1,
  title: 'Deep Dive Bible Study',
  image: 'https://cdn.magicpatterns.com/uploads/s6gFw2wgQMMeputKxJemsQ/WhatsApp_Image_2026-03-13_at_7.30.19_PM.jpg'
}, {
  id: 2,
  title: 'Communion Service',
  image: 'https://cdn.magicpatterns.com/uploads/g2FLwf762fmrFFxfL8vcUk/WhatsApp_Image_2026-03-13_at_7.31.25_PM.jpg'
}, {
  id: 3,
  title: 'Triple-W When We Worship',
  image: 'https://cdn.magicpatterns.com/uploads/4cM78r9dirWzv2hFaMjAik/WhatsApp_Image_2026-03-13_at_7.31.09_PM.jpg'
}, {
  id: 4,
  title: 'Impact Wednesday Revival Service',
  image: 'https://cdn.magicpatterns.com/uploads/i7qsKfq22qq127hrmC3kTK/WhatsApp_Image_2026-03-13_at_7.31.00_PM.jpg'
}, {
  id: 5,
  title: 'Ladies of Excellence Tarry Night',
  image: 'https://cdn.magicpatterns.com/uploads/u3DoDsHQ9gzpBgDTy1eFPq/WhatsApp_Image_2026-03-13_at_7.30.31_PM.jpg'
}];
export function ServiceFlyers() {
  return <section className="py-20 bg-[#0A1F44] overflow-hidden" data-id="element-62">
      <div className="container-custom" data-id="element-63">
        <SectionHeading title="Our Weekly Services" subtitle="Join Us" withLines={true} light={true} data-id="element-64" />

        {/* Desktop Layout: 3 on top, 2 centered on bottom */}
        <div className="hidden md:grid grid-cols-6 gap-6 lg:gap-8 mt-12" data-id="element-65">
          {/* Top Row */}
          {flyers.slice(0, 3).map((flyer, index) => <motion.div key={flyer.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="col-span-2 rounded-xl shadow-2xl overflow-hidden aspect-video group cursor-default" data-id="element-66">
              <img src={flyer.image} alt={flyer.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-67" />
            </motion.div>)}

          {/* Bottom Row */}
          {flyers.slice(3, 5).map((flyer, index) => <motion.div key={flyer.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: (index + 3) * 0.1
        }} className={`col-span-2 rounded-xl shadow-2xl overflow-hidden aspect-video group cursor-default ${index === 0 ? 'col-start-2' : ''}`} data-id="element-68">
              <img src={flyer.image} alt={flyer.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-69" />
            </motion.div>)}
        </div>

        {/* Mobile Layout: Horizontal Scroll */}
        <div className="md:hidden flex overflow-x-auto snap-x snap-mandatory gap-4 pb-6 mt-8 -mx-4 px-4" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-70">
          <style data-id="element-71">{`
            .flyer-scroll::-webkit-scrollbar {
              display: none;
            }
          `}</style>

          {flyers.map((flyer, index) => <motion.div key={flyer.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="min-w-[70vw] max-w-[280px] snap-center rounded-xl shadow-xl overflow-hidden aspect-[3/4] shrink-0" data-id="element-72">
              <img src={flyer.image} alt={flyer.title} className="w-full h-full object-cover object-top" data-id="element-73" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}